import { State } from '../state';

export const documentSale: State = {
    url: 'sales',
    oldUrls: ['sale-documents']
};

export const newDocumentSale: State = {
    url: 'sales/document/new',
    oldUrls: ['sale-document/new'],
    parent: documentSale
};

export const editDocumentSale: State = {
    url: 'sales/document/edit',
    oldUrls: ['sale-document/edit'],
    parent: documentSale
};

export const newProFormaDocument: State = {
    url: 'sales/pro-forma/new',
    oldUrls: ['pro-forma/new'],
    parent: documentSale
};

export const editProFormaDocument: State = {
    url: 'sales/pro-forma/edit',
    oldUrls: ['pro-forma/edit'],
    parent: documentSale
};

export const newAdvanceInvoiceDocument: State = {
    url: 'sales/advance-invoice/new',
    oldUrls: ['advance-invoice/new'],
    parent: documentSale
};

export const editAdvanceInvoiceDocument: State = {
    url: 'sales/advance-invoice/edit',
    oldUrls: ['advance-invoice/edit'],
    parent: documentSale
};

export const newSalePattern: State = {
    url: 'sales/sale-pattern/new',
    oldUrls: ['sale-pattern/new'],
    parent: documentSale
};

export const editSalePattern: State = {
    url: 'sales/sale-pattern/edit',
    oldUrls: ['sale-pattern/edit'],
    parent: documentSale
};

export const salePattern: State = {
    url: 'sales/sale-pattern',
    oldUrls: ['sale-pattern'],
};

export const newAdvanceInvoiceAdjustment: State = {
    url: 'sales/advance-invoice-adjustment/new',
    oldUrls: ['advance-invoice-adjustment/new'],
    parent: documentSale
};

export const editAdvanceInvoiceAdjustment: State = {
    url: 'sales/advance-invoice-adjustment/edit',
    oldUrls: ['advance-invoice-adjustment/edit'],
    parent: documentSale
};

export const newSaleDocumentAdjustment: State = {
    url: 'sales/adjustment/new',
    oldUrls: ['sale-document/new-adjustment'],
    parent: documentSale
};

export const editSaleDocumentAdjustment: State = {
    url: 'sales/adjustment/edit',
    oldUrls: ['sale-document/edit-adjustment'],
    parent: documentSale
};
